import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SubTitle from "../../../components/SubTitle/SubTitle";
import Title from "../../../components/Title/Title";
import PopularCollectionCard from "./PopularCollectionCard";

const PopularCollection = () => {
  const [popularCollection, setPopularCollection] = useState([]);

  useEffect(() => {
    fetch("https://resale-server-two.vercel.app/popular-collection")
      .then((res) => res.json())
      .then((data) => setPopularCollection(data));
  }, []);

  console.log(popularCollection);

  return (
    <div className="max-w-6xl mx-auto">
      <SubTitle>Here is mostly seen top Popular car collection</SubTitle>
      <Title>Popular Collection</Title>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 py-10">
        {popularCollection.map((data) => (
          <PopularCollectionCard
            key={data._id}
            data={data}
          ></PopularCollectionCard>
        ))}
      </div>
      <div className="card-actions justify-center mb-8">
        <Link to="/collection">
          <button className="btn btn-primary px-10 text-white">
            More Collection
          </button>
        </Link>
      </div>
    </div>
  );
};

export default PopularCollection;
